import { WizardType } from '../schemas/Types'

export const canSaveDraft = (wizardType: WizardType) => {
  if (wizardType === 'recommend_more_content') {
    return false
  }

  return true
}
